/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Replace_AnswerInputs */

const en_faq_replace_answer = /** @type {(inputs: Faq_Replace_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We start with the tools you already use. If an integration or access limit gets in the way, we explain the options before proposing a solution.`)
};

const lv_faq_replace_answer = /** @type {(inputs: Faq_Replace_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mēs sākam ar rīkiem, kurus jau lietojat. Ja integrācija vai piekļuves ierobežojums traucē, mēs izskaidrojam iespējas, pirms piedāvājam risinājumu.`)
};

/**
* | output |
* | --- |
* | "We start with the tools you already use. If an integration or access limit gets in the way, we explain the options before proposing a solution." |
*
* @param {Faq_Replace_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_replace_answer = /** @type {((inputs?: Faq_Replace_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Replace_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_replace_answer(inputs)
	return en_faq_replace_answer(inputs)
});